import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SelectModelComponent } from './rttd/routes/select-model/select-model.component';
import { SelectAppointmentComponent } from './rttd/routes/select-appointment/select-appointment.component';
import { PersonalInformationComponent } from './rttd/routes/personal-information/personal-information.component';
import { BookingConfirmationComponent } from './rttd/routes/booking-confirmation/booking-confirmation.component';
import { BookingCancellationComponent } from './shared/routes/booking-cancellation/booking-cancellation.component';
import { BookingCancellationConfirmationComponent } from './shared/routes/booking-cancellation-confirmation/booking-cancellation-confirmation.component';
import { BookingRescheduleComponent } from './shared/routes/booking-reschedule/booking-reschedule.component';
import { ErrorPageComponent } from './shared/routes/error-page/error-page.component';
import { EmptyComponent } from './shared/routes/empty/empty.component';
import { EventsComponent } from './events/routes/events/events.component'
import { EventConfirmationComponent } from './events/routes/event-confirmation/event-confirmation.component'
import { EventAppointmentComponent } from './events/routes/event-appointment/event-appointment.component';
import { EventPersonalInformationComponent } from './events/routes/event-personal-information/event-personal-information.component';


const routes: Routes = [
    {path: 'event', component: EventsComponent},
    {path: 'event-appointment', component: EventAppointmentComponent},
    {path: 'event-confirmation', component: EventConfirmationComponent},
    {path: 'event-personal-information', component: EventPersonalInformationComponent},



    {path: 'select-model', component: SelectModelComponent},
    {path: 'select-appointment', component: SelectAppointmentComponent},
    {path: 'personal-information', component: PersonalInformationComponent},
    {path: 'booking-confirmation', component: BookingConfirmationComponent},
    {path: 'cancel-booking/:id', component: BookingCancellationComponent},
    {path: 'reschedule-booking/:id', component: BookingRescheduleComponent},
    {path: 'booking-cancelled', component: BookingCancellationConfirmationComponent},
    {path: 'error', component: ErrorPageComponent},
    {path: '', component: EmptyComponent},
    {path: '**', redirectTo: ''}
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled', scrollOffset: [0, 120] })],
    exports: []
})
export class AppRoutingModule {
}
